<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><img alt=" " src="Images/FORMATIO_Half.jpg"/></p>
<p class="first">Formatio books from InterVarsity Press follow the rich tradition of the church in the journey of spiritual formation. These books are not merely about being informed, but about being transformed by Christ and conformed to his image. Formatio stands in InterVarsity Press’s evangelical publishing tradition by integrating God’s Word with spiritual practice and by prompting readers to move from inward change to outward witness. InterVarsity Press uses the chambered nautilus for Formatio, a symbol of spiritual formation because of its continual spiral journey outward as it moves from its center. We believe that each of us is made with a deep desire to be in God’s presence. Formatio books help us to fulfill our deepest desires and to become our true selves in light of God’s grace.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// formatio.vue?81e10348